import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
    {
        q: "Où se situe le studio Mon Séraphin ?",
        a: "Le studio est situé au 5 Boulevard Georges Méliès à Villiers-sur-Marne, à 13 minutes à pied de la gare RER A Noisy-le-Grand. Facile d'accès depuis Paris et toute l'Île-de-France.",
    },
    {
        q: "Comment venir au studio en transports en commun ?",
        a: "Mon Séraphin studio est accessible en RER A et RER E.",
    },
    {
        q: "Quelles villes sont desservies par le studio ?",
        a: "Le studio accueille des clients de toute l'Île-de-France : Paris, Villiers-sur-Marne, Noisy-le-Grand, Bry-sur-Marne, Le Perreux-sur-Marne, Nogent-sur-Marne, Champigny-sur-Marne, Neuilly-sur-Marne, Champs-sur-Marne, Torcy et Lognes, en Val-de-Marne, Seine-Saint-Denis et Seine-et-Marne.",
    },
    {
        q: "Puis-je venir en simple découverte avant de m'engager ?",
        a: "Oui. La formule Découverte (90€) vous permet de tester le studio pendant 1h avec setup pro, sans engagement. C'est souvent comme ça qu'on commence.",
    },
    {
        q: "Comment fonctionne l'abonnement mensuel ?",
        a: "L'abonnement à 350€/mois inclut 3h de studio par semaine + un pack de contenu mensuel (shorts, posts, miniatures). Idéal pour les créateurs de contenu, commerçants et entrepreneurs qui veulent publier chaque semaine et maximiser leur diffusion.",
    },
    {
        q: "Le montage est-il inclus dans les formules ?",
        a: "Dans les formules Abonnement et Premium, oui. Pour la Découverte, le montage peut être ajouté en option (à partir de 50€).",
    },
    {
        q: "Puis-je payer sur place au lieu d'en ligne ?",
        a: "Absolument. Au moment de réserver, vous choisissez : paiement en 3 fois sans frais (Scalapay) ou réservation sans paiement — vous réglez ensuite selon nos modalités.",
    },
    {
        q: "Combien de personnes peuvent enregistrer en même temps ?",
        a: "Jusqu'à 4 intervenants simultanément (4 micros broadcast + 4 casques). Un plateau vidéo multi-caméra est disponible en option.",
    },
];

export default function FAQ() {
    return (
        <section
            id="faq"
            className="relative py-24 md:py-32 px-6 md:px-12"
            data-testid="faq-section"
        >
            <div className="max-w-4xl mx-auto">
                <div className="text-center">
                    <span className="font-body text-xs uppercase tracking-[0.25em] text-zinc-500">
                        Questions fréquentes
                    </span>
                    <h2 className="mt-4 font-display text-4xl md:text-5xl font-light tracking-tight text-white">
                        Tout ce que vous devez savoir.
                    </h2>
                </div>

                <div className="mt-14">
                    <Accordion type="single" collapsible className="space-y-3">
                        {faqs.map((f, i) => (
                            <AccordionItem
                                key={i}
                                value={`item-${i}`}
                                className="rounded-2xl border border-white/10 bg-white/[0.02] px-6 overflow-hidden data-[state=open]:border-amber-400/30 data-[state=open]:bg-white/[0.04] transition-colors"
                                data-testid={`faq-item-${i}`}
                            >
                                <AccordionTrigger className="py-5 text-left font-display text-lg font-medium text-white hover:text-amber-300 hover:no-underline">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="pb-5 text-zinc-400 font-body text-base leading-relaxed">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </div>
        </section>
    );
}
